module.exports = __webpack_public_path__ + "static/media/970_01.37583c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/luckyclover/970_01.jpg
// module id = 670
// module chunks = 1